import { render, staticRenderFns } from "./WebshopTea.vue?vue&type=template&id=050bfa7d&scoped=true&"
import script from "./WebshopTea.vue?vue&type=script&lang=js&"
export * from "./WebshopTea.vue?vue&type=script&lang=js&"
import style0 from "./WebshopTea.vue?vue&type=style&index=0&id=050bfa7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050bfa7d",
  null
  
)

export default component.exports